export default __webpack_public_path__ + "static/media/total-runtime.e1c09987.svg";